import React, { memo } from "react";
import { FooterSocialLinks } from "../../utils";

export const Footer = memo(() => {
  return (
    <footer className="sub-section" style={{ backgroundColor: 'var(--surface-primary-contrast)', color: 'var(--text-primary-contrast)' }}>
      <div className="container flex flex-between footer-container">
        <div>
          <p className="label" style={{ marginBottom: 'var(--scale-xl)' }}>get in touch</p>
          <a href="mailto:tusharsingh.contact@gmail.com" className="body-strong">tusharsingh.contact@gmail.com</a>
        </div>
        <div className="flex flex-center footer-socials body-strong">
          {FooterSocialLinks.map((social) => (
          <div
            key={social.name}
            className={`cursor-pointer social-media-icon social-media-icon-${social.name} flex_regular`}
          >
            <a
              aria-label={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className={`fa fa-${social.name}`}></i>
            </a>
          </div>
        ))}
        </div>
      </div>
    </footer>
  );
});

